<template>
  <div>
    <RadioInput v-for="(option, key) of props.options" :key="key" v-model="value" :label="option" :value="key" :name="id">
      <span class="ml-3.5 inline-flex items-baseline py-1.5" :class="{ 'text-base': props.smallerText }">{{ option }}</span>
    </RadioInput>
  </div>
</template>

<script setup lang="ts">
import RadioInput from '~/components/input/RadioInput.vue'

const props = withDefaults(
  defineProps<{
    options: Record<string, string>
    smallerText?: boolean
  }>(),
  {
    smallerText: false,
  }
)

const id = useId()

const value = defineModel<string>({ required: true })
</script>
